$(".contact_block_section").each(function () {
    let section = $(this);
    $(this).find(".location").on("click", function () {
        let latitude = $(this).data("latitude")
        let longitude = $(this).data("longitude")

        let iframe = section.find("iframe")
        let src = `https://maps.google.com/maps?q=${latitude},${longitude}&t=&z=15&ie=UTF8&iwloc=&output=embed`

        if (src != iframe.attr("src")) {
            iframe.attr("src", src)
        }

    })
})

$(".contact_block").each(function () {
    let section = $(this);
    let form = section.find("form");
    let formEl = form[0];

    formEl.submit = function () {
        let submitBtn = form.find('button[type="submit"], input[type="submit"]');
        let originalBtnText = submitBtn.text() || submitBtn.val();
        submitBtn.prop("disabled", true).text("Submitting...");
        form.find(".field_error").remove();

        $.ajax({
            url: form.attr("action"),
            method: "POST",
            data: form.serialize(),
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            },
            success: function () {
                window.location.href = "/contact/success";
            },
            error: function (xhr) {
                if (xhr.responseJSON && xhr.responseJSON.errors) {
                    $.each(xhr.responseJSON.errors, function (field, messages) {
                        let input = form.find('[name="' + field + '"]');
                        let errorHtml = '<span class="field_error" style="color:red;display:block;">' + messages.join(', ') + '</span>';
                        input.closest('.quiver_field, .mb-3').append(errorHtml);
                    });
                } else {
                    section.find(".success_message").css("color", "red").text("There was an error submitting your enquiry. Please try again.").show();
                }
                submitBtn.prop("disabled", false).text(originalBtnText);
            }
        });
    };
});

$(".newsletter_signup_section").each(function () {
    let section = $(this);
    let form = section.find("form");

    form.on("submit", function (e) {
        e.preventDefault();

        let submitBtn = form.find('button[type="submit"], input[type="submit"]');
        let originalBtnText = submitBtn.text() || submitBtn.val();
        submitBtn.prop("disabled", true).text("Submitting...");

        $.ajax({
            url: form.attr("action"),
            method: "POST",
            data: form.serialize(),
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            },
            success: function (response) {
                form.find(".quiver_field").remove();
                form.find(".success_message").css("color", "black").text(response.message).show();
                form.find("button").remove();
                // alert(response.message);
            },
            error: function (xhr) {
                let message = "There was an error subscribing to our newsletter.";
                if (xhr.responseJSON && xhr.responseJSON.errors) {
                    let errors = xhr.responseJSON.errors;
                    message = Object.values(errors).flat().join("\n");
                }
                // form.find(".quiver_field").remove();
                form.find(".success_message").css("color", "red").text(message).show();
                // form.find("button").remove();
            },
            complete: function () {
                submitBtn.prop("disabled", false).text(originalBtnText);
            }
        });
    });
});

$(function () {
    const fadeDuration = 150;
    const leaveDelay = 200;

    $(".nav_dropdown").each(function () {
        const $trigger = $(this);
        const dropdown_id = $(this).data("dropdown-id");
        const $menu = $(`.dropdown_container[data-id="${dropdown_id}"]`);
        let hideTimer = null;

        function show() {
            clearTimeout(hideTimer);
            $menu.stop(true, false).fadeIn(fadeDuration);
        }

        function hideSoon() {
            clearTimeout(hideTimer);
            hideTimer = setTimeout(() => {
                $menu.stop(true, false).fadeOut(fadeDuration);
            }, leaveDelay);
        }

        $trigger.on("mouseenter", show);
        $trigger.on("mouseleave", hideSoon);

        $menu.on("mouseenter", function () {
            clearTimeout(hideTimer);
            $menu.stop(true, false).fadeIn(fadeDuration);
        });
        $menu.on("mouseleave", hideSoon);
    });
});

$(document).ready(function(){
    $('.mobile-toggle').click(function(){
        $('nav .links').toggleClass('active');
    });

    function openSlidePanel() {
        $('.slide-panel').addClass('open');
        $('.page-overlay').removeClass('hidden');
        setTimeout(function() {
            $("#id_text").focus();
        }, 300);
    }

    function closeSlidePanel() {
        $('.slide-panel').removeClass('open');
        $('.page-overlay').addClass('hidden');
    }

    $(".open-slide-panel-button").on("click", function(e) {
        e.preventDefault();
        openSlidePanel();
        $("body").addClass("no-scroll");
    });

    $(".close-slide-panel-button").on("click", function(e) {
        e.preventDefault();
        closeSlidePanel();
        $("body").removeClass("no-scroll");
    });

    function openMobileNav() {
        $('.mobile-nav-panel').addClass('open');
        $('.mobile-nav-overlay').removeClass('hidden');
        $("body").addClass("no-scroll");
    }

    function closeMobileNav() {
        $('.mobile-nav-panel').removeClass('open');
        $('.mobile-nav-overlay').addClass('hidden');
        $("body").removeClass("no-scroll");
    }

    $(".mobile_nav_toggle").on("click", function(e) {
        e.preventDefault();
        openMobileNav();
    });

    $(".close-mobile-nav-button").on("click", function(e) {
        e.preventDefault();
        closeMobileNav();
    });

    // Mobile nav dropdown toggles
    $(".mobile-nav-toggle-icon").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $icon = $(this);
        var $dropdown = $icon.closest('.mobile-nav-dropdown');
        var $children = $dropdown.find('> .mobile-nav-children').first();
        var isOpening = !$children.is(':visible');

        // Get all top-level items (direct children of .mobile-nav-links)
        var $allTopLevelItems = $('.mobile-nav-links > a, .mobile-nav-links > .mobile-nav-dropdown');

        // Check if this is a top-level dropdown
        var isTopLevel = $dropdown.parent().hasClass('mobile-nav-links');

        if (isTopLevel) {
            if (isOpening) {
                // Close all other top-level dropdowns
                $('.mobile-nav-links > .mobile-nav-dropdown').not($dropdown).each(function() {
                    var $otherDropdown = $(this);
                    var $otherChildren = $otherDropdown.find('> .mobile-nav-children').first();
                    var $otherIcon = $otherDropdown.find('> .mobile-nav-parent > .mobile-nav-toggle-icon');

                    if ($otherChildren.is(':visible')) {
                        $otherChildren.slideUp(300);
                        $otherIcon.removeClass('open');
                    }
                });

                // Fade all top-level items to 0.25
                $allTopLevelItems.css({
                    'opacity': '0.25',
                    'transition': 'opacity 0.3s ease'
                });

                // Bring the clicked dropdown to full opacity
                $dropdown.css({
                    'opacity': '1',
                    'transition': 'opacity 0.3s ease'
                });

                // Open the clicked dropdown
                $children.slideDown(300);
                $icon.addClass('open');
            } else {
                // Close the dropdown
                $children.slideUp(300);
                $icon.removeClass('open');

                // Restore opacity to all top-level items
                $allTopLevelItems.css({
                    'opacity': '1',
                    'transition': 'opacity 0.3s ease'
                });
            }
        } else {
            // For nested dropdowns, just toggle normally
            $children.slideToggle(300);
            $icon.toggleClass('open');
        }
    });

    // Mini Cart Sidebar
    function openMiniCart() {
        $('.mini-cart-panel').addClass('open');
        $('.mini-cart-overlay').removeClass('hidden');
        $("body").addClass("no-scroll");
    }

    function closeMiniCart() {
        $('.mini-cart-panel').removeClass('open');
        $('.mini-cart-overlay').addClass('hidden');
        $("body").removeClass("no-scroll");
    }

    $(document).on("click", ".mini-cart-trigger", function(e) {
        e.preventDefault();
        openMiniCart();
    });

    $(".close-mini-cart-button").on("click", function(e) {
        e.preventDefault();
        closeMiniCart();
    });

    $(document).on('keydown', function(e) {
        if (e.key === "Escape") {
            if ($('.slide-panel').hasClass('open')) {
                closeSlidePanel();
            }
            if ($('.mobile-nav-panel').hasClass('open')) {
                closeMobileNav();
            }
            if ($('.mini-cart-panel').hasClass('open')) {
                closeMiniCart();
            }
        }
    });
});
let announcementBar = document.querySelector(".announcementBar");
if (announcementBar && announcementBar.querySelectorAll(".swiper-slide").length > 1) {
    let perRow = parseInt(announcementBar.dataset.perRow) || 1;
    new Swiper(announcementBar, {
        slidesPerView: 1,
        loop: true,
        autoplay: { delay: 4000 },
        breakpoints: {
            768: { slidesPerView: Math.min(perRow, 2) },
            1024: { slidesPerView: perRow },
        },
    });
}
